import * as React from 'react'

const DottedLine = (props) => (
	<svg
		width='22'
		height='6'
		viewBox='0 0 22 6'
		fill={props.fill ?? 'none'}
		xmlns='http://www.w3.org/2000/svg'
		{...props}
	>
		<circle
			cx={3}
			cy={3}
			r={2.5}
		/>
		<circle
			cx={11}
			cy={3}
			r={2.5}
		/>
		<circle
			cx={19}
			cy={3}
			r={2.5}
		/>
	</svg>
)

export default DottedLine
